import React from "react";
import { Link , useNavigate} from "react-router-dom";
import "../../Create_Assessment_PreRead/create_successfullPreRead/successfullPreRead.css";

const SuccessfullPreRead = () => {
  const navigate = useNavigate();
  let Header=localStorage.getItem("Header");
  const OkayClickHandle=()=>{
    navigate(Header==="Content Management (Pre-read)"?"/contentMangment":"/PublishedHomeworkPreRead")
    if(Header==="Content Management (Pre-read)"){
      localStorage.setItem("Header","Content Management");
    }
  }
  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        <img className="prereadLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" mb-4 mt-2 successfully_message">
          You have successfully created Pre-Read.
        </span>
        <button className="successfull_okay_btn" onClick={()=>{OkayClickHandle()}}>Okay</button>
      </div>
    </div>
  );
};

export default SuccessfullPreRead;
